import React, { useState, useEffect, useCallback } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { serverApi } from '../../api';

const MySwal = withReactContent(Swal);

export const RolesPantallasSuperAdmin = () => {
    const [roles, setRoles] = useState([]);
    const [pantallas, setPantallas] = useState([]);
    const [selectedRol, setSelectedRol] = useState(null);
    const [rolPantallas, setRolPantallas] = useState([]);
    const [loading, setLoading] = useState(false);

    // Form Rol
    const [nuevoRol, setNuevoRol] = useState('');

    // Form Pantalla
    const [codigoPantalla, setCodigoPantalla] = useState('');
    const [nombrePantalla, setNombrePantalla] = useState('');

    const cargarCatalogos = useCallback(async () => {
        try {
            setLoading(true);
            const [respRoles, respPantallas] = await Promise.all([
                serverApi.get('/superadmin/roles'),
                serverApi.get('/superadmin/pantallas'),
            ]);

            if (respRoles.data.ok) setRoles(respRoles.data.roles || []);
            if (respPantallas.data.ok) setPantallas(respPantallas.data.pantallas || []);
        } catch (error) {
            console.error("Error al cargar roles y pantallas:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        cargarCatalogos();
    }, [cargarCatalogos]);

    const cargarPermisosRol = async (rol) => {
        setSelectedRol(rol);
        try {
            const resp = await serverApi.get(`/superadmin/rol-pantallas?uidRol=${rol.uidRol}`);
            if (resp.data.ok) {
                setRolPantallas(resp.data.pantallas || []);
            }
        } catch (error) {
            console.error("Error al cargar permisos del rol:", error);
        }
    };

    const handleCrearRol = async (e) => {
        e.preventDefault();
        if (!nuevoRol.trim()) return;

        try {
            setLoading(true);
            const resp = await serverApi.post('/superadmin/roles', { rol: nuevoRol.trim() });
            if (resp.data.ok) {
                MySwal.fire({
                    title: '¡Rol Creado!',
                    text: resp.data.msg,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                });
                setNuevoRol('');
                cargarCatalogos();
            } else {
                MySwal.fire('Atención', resp.data.msg, 'error');
            }
        } catch (error) {
            MySwal.fire('Error', 'Error al registrar rol', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleCrearPantalla = async (e) => {
        e.preventDefault();
        if (!codigoPantalla.trim() || !nombrePantalla.trim()) return;

        try {
            setLoading(true);
            const resp = await serverApi.post('/superadmin/pantallas', {
                codigoPantalla: codigoPantalla.trim().toLowerCase(),
                pantalla: nombrePantalla.trim(),
            });
            if (resp.data.ok) {
                MySwal.fire({
                    title: '¡Pantalla Creada!',
                    text: resp.data.msg,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                });
                setCodigoPantalla('');
                setNombrePantalla('');
                cargarCatalogos();
            } else {
                MySwal.fire('Atención', resp.data.msg, 'error');
            }
        } catch (error) {
            MySwal.fire('Error', 'Error al registrar pantalla', 'error');
        } finally {
            setLoading(false);
        }
    };

    const handleTogglePantallaPermiso = (codPantalla) => {
        setRolPantallas(prev =>
            prev.includes(codPantalla)
                ? prev.filter(p => p !== codPantalla)
                : [...prev, codPantalla]
        );
    };

    const handleGuardarPermisos = async () => {
        if (!selectedRol) return;
        try {
            setLoading(true);
            const resp = await serverApi.post('/superadmin/rol-pantallas', {
                uidRol: selectedRol.uidRol,
                pantallas: rolPantallas,
            });

            if (resp.data.ok) {
                MySwal.fire({
                    title: '¡Permisos Guardados!',
                    text: resp.data.msg,
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false,
                });
            } else {
                MySwal.fire('Error', resp.data.msg, 'error');
            }
        } catch (error) {
            MySwal.fire('Error', 'Error al guardar permisos', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
            {/* PANEL IZQUIERDO: ROLES GLOBALES */}
            <div style={{ background: '#ffffff', borderRadius: 16, padding: 24, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0' }}>
                <h4 style={{ margin: '0 0 4px', fontWeight: 800, color: '#0f172a' }}>🛡️ Roles Globales</h4>
                <p style={{ margin: '0 0 16px', color: '#64748b', fontSize: 13 }}>
                    Roles disponibles para todas las empresas de la plataforma
                </p>

                {/* Formulario nuevo rol */}
                <form onSubmit={handleCrearRol} style={{ display: 'flex', gap: 10, marginBottom: 20 }}>
                    <input
                        type="text"
                        placeholder="Nombre del Rol (Ej: AUDITOR)"
                        value={nuevoRol}
                        onChange={e => setNuevoRol(e.target.value.toUpperCase())}
                        style={{
                            flex: 1, padding: '10px 14px', borderRadius: 10,
                            border: '1.5px solid #cbd5e1', fontSize: 14, fontWeight: 600,
                        }}
                    />
                    <button
                        type="submit"
                        disabled={loading || !nuevoRol.trim()}
                        style={{
                            background: '#0d7367', color: 'white', border: 'none',
                            borderRadius: 10, padding: '10px 18px', fontWeight: 700,
                            cursor: 'pointer', whiteSpace: 'nowrap',
                        }}
                    >
                        ➕ Crear Rol
                    </button>
                </form>

                {/* Tabla de Roles */}
                <div style={{ maxHeight: 320, overflowY: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: 13 }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0', color: '#475569' }}>
                                <th style={{ padding: '10px 14px' }}>Rol</th>
                                <th style={{ padding: '10px 14px', textAlign: 'center' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {roles.length === 0 ? (
                                <tr>
                                    <td colSpan="2" style={{ textAlign: 'center', padding: 20, color: '#94a3b8' }}>
                                        No hay roles globales creados.
                                    </td>
                                </tr>
                            ) : (
                                roles.map(r => (
                                    <tr
                                        key={r.uidRol}
                                        style={{
                                            borderBottom: '1px solid #f1f5f9',
                                            background: selectedRol?.uidRol === r.uidRol ? '#f0fdf4' : 'transparent',
                                        }}
                                    >
                                        <td style={{ padding: '12px 14px', fontWeight: 700, color: '#0f172a' }}>
                                            {r.rol}
                                        </td>
                                        <td style={{ padding: '12px 14px', textAlign: 'center' }}>
                                            <button
                                                type="button"
                                                onClick={() => cargarPermisosRol(r)}
                                                style={{
                                                    background: selectedRol?.uidRol === r.uidRol ? '#0d7367' : '#e2e8f0',
                                                    color: selectedRol?.uidRol === r.uidRol ? 'white' : '#334155',
                                                    border: 'none', borderRadius: 8, padding: '6px 12px',
                                                    fontWeight: 700, cursor: 'pointer', fontSize: 12,
                                                }}
                                            >
                                                {selectedRol?.uidRol === r.uidRol ? '✓ Asignando' : '⚙️ Permisos'}
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* PANEL DERECHO: PANTALLAS GLOBALES & PERMISOS */}
            <div style={{ background: '#ffffff', borderRadius: 16, padding: 24, boxShadow: '0 4px 20px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0' }}>
                <h4 style={{ margin: '0 0 4px', fontWeight: 800, color: '#0f172a' }}>📺 Pantallas del Sistema</h4>
                <p style={{ margin: '0 0 16px', color: '#64748b', fontSize: 13 }}>
                    Catálogo de módulos y pantallas accesibles en el sistema
                </p>

                {/* Formulario nueva pantalla */}
                <form onSubmit={handleCrearPantalla} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr auto', gap: 10, marginBottom: 20 }}>
                    <input
                        type="text"
                        placeholder="Código (Ej: usuarios)"
                        value={codigoPantalla}
                        onChange={e => setCodigoPantalla(e.target.value)}
                        style={{
                            padding: '10px 14px', borderRadius: 10,
                            border: '1.5px solid #cbd5e1', fontSize: 13, fontWeight: 600,
                        }}
                    />
                    <input
                        type="text"
                        placeholder="Nombre (Ej: Gestión Usuarios)"
                        value={nombrePantalla}
                        onChange={e => setNombrePantalla(e.target.value)}
                        style={{
                            padding: '10px 14px', borderRadius: 10,
                            border: '1.5px solid #cbd5e1', fontSize: 13, fontWeight: 600,
                        }}
                    />
                    <button
                        type="submit"
                        disabled={loading || !codigoPantalla.trim() || !nombrePantalla.trim()}
                        style={{
                            background: '#0d7367', color: 'white', border: 'none',
                            borderRadius: 10, padding: '10px 16px', fontWeight: 700,
                            cursor: 'pointer', whiteSpace: 'nowrap',
                        }}
                    >
                        ➕ Crear
                    </button>
                </form>

                {/* MATRIZ DE PERMISOS SI HAY ROL SELECCIONADO */}
                {selectedRol ? (
                    <div style={{ background: '#f8fafc', borderRadius: 12, padding: 16, border: '1px solid #cbd5e1' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                            <span style={{ fontWeight: 800, color: '#0d7367', fontSize: 14 }}>
                                Permisos para el Rol: <span style={{ textDecoration: 'underline' }}>{selectedRol.rol}</span>
                            </span>
                            <button
                                type="button"
                                onClick={handleGuardarPermisos}
                                disabled={loading}
                                style={{
                                    background: 'linear-gradient(135deg, #0d7367 0%, #14b8a6 100%)',
                                    color: 'white', border: 'none', borderRadius: 8,
                                    padding: '8px 16px', fontWeight: 800, fontSize: 13, cursor: 'pointer',
                                }}
                            >
                                💾 Guardar Permisos
                            </button>
                        </div>

                        <div style={{ maxHeight: 260, overflowY: 'auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                            {pantallas.map(p => {
                                const isChecked = rolPantallas.includes(p.codigoPantalla);
                                return (
                                    <label
                                        key={p.codigoPantalla}
                                        style={{
                                            display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px',
                                            borderRadius: 8, background: isChecked ? '#e6f4f2' : '#ffffff',
                                            border: `1px solid ${isChecked ? '#0d7367' : '#e2e8f0'}`,
                                            cursor: 'pointer', fontSize: 13, fontWeight: isChecked ? 700 : 500,
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={isChecked}
                                            onChange={() => handleTogglePantallaPermiso(p.codigoPantalla)}
                                        />
                                        <div>
                                            <div>{p.pantalla}</div>
                                            <small style={{ fontSize: 11, color: '#64748b' }}>({p.codigoPantalla})</small>
                                        </div>
                                    </label>
                                );
                            })}
                        </div>
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: 40, color: '#64748b', background: '#f8fafc', borderRadius: 12, border: '1px dashed #cbd5e1' }}>
                        👉 Seleccione un rol de la lista de la izquierda para configurar sus pantallas y permisos.
                    </div>
                )}
            </div>
        </div>
    );
};
